import { createSignal } from '@react-rxjs/utils'
import { bind } from '@react-rxjs/core'
import { BluetoothStatus } from '../hooks/useBluetooth/useBluetooth'

export const [bluetoothDeviceChanged$, setBluetoothDevice] = createSignal<BluetoothDevice | null>()
export const [useBluetoothDevice, bluetoothDevice$] = bind(bluetoothDeviceChanged$, null)

export const [bluetoothCharacteristicsChanged$, setBluetoothCharacteristics] = createSignal<Map<
    string,
    BluetoothRemoteGATTCharacteristic
> | null>()
export const [useBluetoothCharacteristics, bluetoothCharacteristics$] = bind(
    bluetoothCharacteristicsChanged$,
    null,
)

export const [deviceStatusChanged$, setDeviceStatus] = createSignal<BluetoothStatus>()
export const [useDeviceStatus, deviceStatus$] = bind(deviceStatusChanged$, BluetoothStatus.Idle)

export const [deviceBatteryChanged$, setDeviceBattery] = createSignal<number>()
export const [useDeviceBattery, deviceBattery$] = bind(deviceBatteryChanged$, 0)

export const [deviceBatteryStatusChanged$, setDeviceBatteryStatus] = createSignal<
    'unknown' | 'needs-charging' | 'low' | 'ok' | 'full'
>()
export const [useDeviceBatteryStatus, deviceBatteryStatus$] = bind(
    deviceBatteryStatusChanged$,
    'unknown',
)

export const [deviceInfoChanged$, setDeviceInfo] = createSignal<{
    deviceId?: string
    deviceUid?: string
    deviceSoftware?: string
}>()

export const [useDeviceInfo, deviceInfo$] = bind(deviceInfoChanged$, {
    deviceId: '',
    deviceUid: '',
    deviceSoftware: '',
})

export const [lastThrowUploadChanged$, setLastThrowUpload] = createSignal<number>()
export const [useLastThrowUpload, lastThrowUpload$] = bind(lastThrowUploadChanged$, 0)
